// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1DyLI","buttons":"SendReceipts_buttons__3LAT6","email":"SendReceipts_email__AycCH","bookApptTitle":"SendReceipts_bookApptTitle__pTen-"};